import { Component, OnDestroy } from '@angular/core';
import { StoreService } from '../../services/store.service';

@Component({
  selector: 'unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  styleUrls: ['./unauthorized-page.component.scss']
})
export class UnauthorizedPageComponent implements OnDestroy {

  constructor(
    private store: StoreService
  ) {
    this.store.hideProjectSelector()
  }

  ngOnDestroy(): void {
    this.store.showProjectSelector();
  }

}
